<template>
  <div class="el-container empty-page-root" :style="{background: require('./back.png')}">
    <keep-alive>
      <router-view class="empty-route-view"/>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'empty'
}
</script>

<style scoped lang="scss">
.empty-page-root {
  min-height: 100%;
  min-width: 100%;
  /*background-color: #f6f7f8;*/
  .empty-route-view {
    min-height: 100%;
    min-width: 100%;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/empty/index.vue